import type { CountryCode } from '@hotjar/country-lib';
import { client } from '@hotjar/api-base-client';
import type { PaymentDetailsConfig } from './model';

const BASE_URL_PATH = '/api/checkout/payment-pages/configuration';

export const getConfigurationsFromCountryCode = async (
  countryCode: CountryCode,
): Promise<PaymentDetailsConfig[]> => {
  const { configurations } = await client<{ configurations: PaymentDetailsConfig[] }>({
    url: `${BASE_URL_PATH}/${countryCode}`,
  });
  return configurations;
};

export const getConfigurationsFromCustomerId = async (
  customerId: number,
): Promise<PaymentDetailsConfig[]> => {
  const { configurations } = await client<{ configurations: PaymentDetailsConfig[] }>({
    url: `${BASE_URL_PATH}/customers/${customerId}`,
  });
  return configurations;
};
